import { Colors, Metrics, Typography } from "../../resources";
import {
  IIconButtonModal,
  Orientation,
  STagType,
  Space,
  Tag,
  TagMap,
} from "../../types";
import React, { useState } from "react";
import { SButton, SSpacer } from "../atoms";
import { ScrollView, StyleSheet, Text, View } from "react-native";
import { Toast, Toaster } from "@density/ui";
import _, { noop } from "lodash";
import { getTagId, getTagName } from "../../utils";

import STagsBar from "../molecules/STagsBar";
import { useTags } from "../../hooks";

interface IProps extends IIconButtonModal {
  selected: number;
  spaces: Space[];
  onDeleteTag: (tag: Tag) => void;
  onAddTag: (tag: Tag) => void;
  onSave: () => void;
}

const SEditTagsModal: React.FC<IProps> = ({
  selected,
  spaces,
  onDeleteTag,
  onAddTag,
  onSave,
  onCancel = noop,
}) => {
  const [toastVisible, setToastVisible] = useState<boolean>(false);
  const [addTags, setAddTags] = useState<TagMap>({});
  const [deleteTags, setDeleteTags] = useState<TagMap>({});
  const [editedAddTag, setEditedAddTag] = useState<TagMap>({});
  const { tags } = useTags();

  let finalTags = tags;
  Object.keys(finalTags).map((id: string) => {
    let shared = true;
    for (let space of spaces) {
      if (!space.tags.find((tag: string) => tag === id)) {
        shared = false;
        break;
      }
    }
    finalTags[id].shared = shared;
  });

  let selectedTags: Set<string> = new Set();
  for (let space of spaces) {
    space.tags.map((tag: string) => {
      selectedTags.add(tag);
    });
  }
  let tagsFinal: TagMap = {};
  Array.from(selectedTags).map((tag: string) => {
    const { name, category } = getTagName(tag);

    if (!Object.keys(deleteTags).includes(tag)) {
      tagsFinal[tag] = {
        title: name,
        category: category,
        number: 0,
        selected: false,
        disabled: false,
        shared: finalTags[tag].shared ? finalTags[tag].shared : false,
      };
    }
  });
  // Add Added tags to the modal
  Object.keys(addTags).map((id: string) => {
    tagsFinal[id] = addTags[id];
  });

  // Remove deleted tags from modal

  //  setTagsFinal(_tagsFinal);
  // }, [tags]);

  const onLocalAddTag = (tag: Tag) => {
    let tagMap = _.cloneDeep(addTags);
    tagMap[getTagId(tag.title, tag.category)] = tag;
    setAddTags(tagMap);
  };

  const onLocalDeleteTag = (tag: Tag) => {
    let tagMap = _.cloneDeep(deleteTags);
    tagMap[getTagId(tag.title, tag.category)] = tag;
    setDeleteTags(tagMap);
  };

  const applyEditTags = () => {
    Object.keys(addTags).map((id: string) => {
      const _tag = addTags[id];
      onAddTag(_tag);
    });
    if (editedAddTag !== null) {
      Object.keys(editedAddTag).map((id: string) => {
        const _tag = editedAddTag[id];
        onAddTag(_tag);
      });
    }
    Object.keys(deleteTags).map((id: string) => {
      const _tag = deleteTags[id];
      onDeleteTag(_tag);
    });
    setAddTags({});
    setDeleteTags({});
    onSave();
    onCancel();
    Toaster.showToast({
      text: "Bulk tags change successful",
      timeout: 2000,
    });
  };

  const onEditedAddTag = (tag: TagMap) => {
    setEditedAddTag(tag);
  };

  const cancelModal = () => {
    onCancel();
    setAddTags({});
    setDeleteTags({});
  };

  const dismissToast = () => {
    setToastVisible(false);
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={{ alignItems: "center", flexDirection: "row" }}>
          <Text style={styles.titleText}>{"Edit Tags on  "}</Text>
          <View
            style={{
              height: 24,
              width: 24,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 12,
              backgroundColor: Colors.yellow300,
              paddingHorizontal: 4,
            }}
          >
            <Text style={styles.titleText}>{selected}</Text>
          </View>
          <Text style={styles.titleText}>{"  selected spaces"}</Text>
        </View>
      </View>
      <ScrollView>
        <View style={styles.content}>
          <STagsBar
            tags={tagsFinal}
            type={STagType.Edited}
            onEditedAddTag={onEditedAddTag}
            onClick={onLocalDeleteTag}
            onEdit={onLocalAddTag}
            flexWrap
          />
        </View>
      </ScrollView>
      <View style={styles.footer}>
        <SButton
          onPress={cancelModal}
          style={{ height: Metrics.iconLarge, width: 64 }}
          color={Colors.blue700}
          backgroundColor={Colors.white}
          textColor={Colors.blue700}
        >
          Cancel
        </SButton>
        <SSpacer space={Metrics.padding8} type={Orientation.Horizontal} />
        <SButton
          onPress={applyEditTags}
          style={{ height: Metrics.iconLarge, width: 64 }}
        >
          Save
        </SButton>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    width: Metrics.editModalWidth,
    height: Metrics.editModalHeight,
    left: 0,
    top: Metrics.size32 + 2,
    backgroundColor: Colors.white,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.grey200,
    shadowColor: "#03082e",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 4,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.grey000,
    height: 48,
  },
  titleText: {
    ...Typography.title,
    color: Colors.grey900,
    textTransform: "uppercase",
  },
  content: {
    height: 64,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 16,
  },
  footer: {
    flexDirection: "row",
    height: 48,
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: 8,
    borderTopWidth: 1,
    borderColor: Colors.grey200,
  },
});

export default SEditTagsModal;
